import { router } from 'expo-router';
import * as React from 'react';
import {
    ArrowLeftIcon,
    BackButton,
    BackButtonIconType,
    BodyLargeRegular,
    BodyMediumRegular,
    Button,
    ButtonSize,
    ButtonVariant,
    FullScreenContainer,
    H1Emphasized,
    HomeIcon,
    Icon,
    SearchIcon,
    YStack,
} from 'smoothie';

import LogRocketFacade from '../../logger/log-rocket/LogRocketFacade';

const NotFound = () => {
    LogRocketFacade.tagPage('NotFound');

    const canGoBack = router.canGoBack();

    const handleGoHome = () => {
        router.replace('/');
    };

    const handleGoBack = () => {
        router.back();
    };

    return (
        <FullScreenContainer
            header={
                <BackButton
                    fallbackRoute="/"
                    iconType={BackButtonIconType.LEFT}
                />
            }
        >
            <YStack
                flex={1}
                alignItems="center"
                justifyContent="center"
                paddingHorizontal={24}
                gap={24}
            >
                {/* 404 Icon */}
                <YStack alignItems="center" gap={16}>
                    <Icon
                        icon={SearchIcon}
                        size={64}
                        color="$gray600"
                        opacity={0.3}
                    />
                    <H1Emphasized color="$gray1000" textAlign="center">
                        404
                    </H1Emphasized>
                </YStack>

                {/* Error Message */}
                <YStack alignItems="center" gap={12} maxWidth={400}>
                    <H1Emphasized color="$black" textAlign="center">
                        Page Not Found
                    </H1Emphasized>
                    <BodyLargeRegular color="$gray1000" textAlign="center">
                        This page might have been moved or is temporarily
                        unavailable.
                    </BodyLargeRegular>
                    <BodyMediumRegular color="$gray800" textAlign="center">
                        Let&apos;s get you back to where you need to be.
                    </BodyMediumRegular>
                </YStack>

                {/* Action Buttons */}
                <YStack gap={16} width="100%" maxWidth={300}>
                    {canGoBack && (
                        <Button
                            variant={ButtonVariant.SECONDARY}
                            size={ButtonSize.LARGE}
                            text="Go Back"
                            icon={ArrowLeftIcon}
                            iconPosition="left"
                            onPress={handleGoBack}
                        />
                    )}
                    <Button
                        variant={ButtonVariant.PRIMARY}
                        size={ButtonSize.LARGE}
                        text="Go to Home"
                        icon={HomeIcon}
                        iconPosition="left"
                        onPress={handleGoHome}
                    />
                </YStack>
            </YStack>
        </FullScreenContainer>
    );
};

export default NotFound;
